module.exports = __webpack_public_path__ + "static/img/gmn.ebe420b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gmn.jpg
// module id = oCFk
// module chunks = 1